import { createStyles } from '@mui/styles';

// Types
import { APTheme } from '../../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
  formControl: {
    '& .MuiSvgIcon-root': {
      fontSize: '2rem'
    },
    '& .MuiAutocomplete-input': {
      paddingLeft: '6px !important'
    }
  },
  inputIcon: {
    height: 20,
    left: 15,
    position: 'absolute',
    top: 17,
    width: 20
  },
  hasIcon: {
    '& .MuiAutocomplete-input': {
      paddingLeft: '30px !important'
    }
  },
  popper: {
    '& .MuiAutocomplete-paper': {
      minWidth: 300
    }
  },
  customPopper: {
    '& .MuiAutocomplete-paper': {
      minWidth: 100,
      borderRadius: '0px 0px 4px 4px',
    },
    '& .MuiAutocomplete-listbox': {
      padding: '4px 12px 8px 12px',
      border: '1.5px solid #2D91E9',
      borderTop: 'none',
      borderRadius: '0px 0px 4px 4px',
      boxShadow: 'none',
      '& .MuiAutocomplete-option': {
        padding: 8,
        borderRadius: 4,
        marginBottom: 4,
        '& > img': {
          height: 16,
          width: 16
        },
        '&[aria-selected="true"]': {
          color: '#FFFFFF',
          backgroundColor: '#2D91E9 !important'
        },
        '&.Mui-focused': {
          backgroundColor: '#EAF3FF'
        }
      }
    }
  },
  customAccountPopper: {
    '& .MuiAutocomplete-paper': {
      minWidth: 400,
      borderRadius: '0px 0px 4px 4px',
      '@media(max-width: 990px)': {
        minWidth: '-webkit-fill-available'
      }
    },
    '& .MuiAutocomplete-listbox': {
      padding: '4px 16px 12px 16px',
      border: '1.5px solid #2D91E9',
      borderTop: 'none',
      borderRadius: '0px 0px 4px 4px',
      boxShadow: 'none',
      maxHeight: '70vh',
      '& .MuiAutocomplete-option': {
        padding: '12px 16px',
        borderRadius: 4,
        marginBottom: 4,
        '&:last-child': {
          marginBottom: 0
        },
        '& > img': {
          height: 20,
          width: 20
        },
        '& > div > div:last-child': {
          fontSize: '1rem',
          fontWeight: 400
        },
        '&[aria-selected="true"]': {
          color: '#FFFFFF',
          backgroundColor: '#2D91E9 !important'
        },
        '&[aria-selected="false"]': {
          '& > div:last-child': {
            display: 'none'
          }
        },
        '&.Mui-focused': {
          backgroundColor: '#EAF3FF'
        }
      }
    }
  },
  textFieldWrapper: {
    position: 'relative'
  },
  helperText: {
    color: '#a4a4a4',
    fontSize: 12,
    marginTop: 5,
    marginLeft: 0,
  },
  stateIcon: {
    backgroundColor: '#FFF',
    borderRadius: 100,
    height: 20,
    padding: 2,
    position: 'absolute',
    right: -8,
    top: -8,
    width: 20
  },
  popupIndicator: {
    padding: '6px 4px 2px 4px',
    '&.MuiAutocomplete-popupIndicatorOpen': {
      padding: '4px 4px 4px 4px',
    },
    marginRight: 0,
    "& span": {
      "& svg": {
        fontSize: '125%',
        "& path": {
          d: "path('M11 15.125L4.125 8.25L5.0875 7.2875L11 13.2L16.9125 7.2875L17.875 8.25L11 15.125Z')" // your svg icon path here
        }
      }
    }
  }
});
